import React from "react";

export const handleVirtualTourClick = (e: React.MouseEvent<HTMLElement>, url: string) => {
  e.preventDefault();

  const backUrl = typeof window !== "undefined" ? window.location.href : process.env.NEXT_PUBLIC_APP_URL;
  let updatedUrl = url;

  if (typeof window !== "undefined") {
    const urlObject = new URL(url);
    const searchParams = new URLSearchParams(urlObject.search);

    searchParams.set("backUrl", backUrl as string);

    updatedUrl = `${url.replace(urlObject.search, "")}?${searchParams.toString()}`;
  }

  window.open(updatedUrl);
}
